// Mock data for Dere Pastanesi website

export const translations = {
  tr: {
    // Navigation
    home: 'Ana Sayfa',
    about: 'Hakkımızda',
    menu: 'Menü',
    reviews: 'Yorumlar',
    gallery: 'Galeri',
    contact: 'İletişim',
    
    // Hero Section
    heroTitle: 'Her Gün Taze, Her Zaman Kaliteli',
    heroSubtitle: 'Ankara\'nın sevilen köklü pastanesi. 1971\'den beri.',
    viewMenu: 'Menüyü İncele',
    getDirections: 'Yol Tarifi Al',
    callNow: 'Hemen Ara',
    
    // About Section
    aboutTitle: 'Hakkımızda',
    aboutText1: '1971 yılında Hüseyin Sünetci tarafından Ankara Başlayan Sokak\'ta hizmete giren Dere Pastanesi, ilerleyen zamanlarda yelpazesini genişleterek Bülbülderesi Caddesinde hizmetini sürdürerek Ankara\'nın ilk ve sayılı pastaneleri arasında yer almaktadır. Pastanemiz 2007 yılı itibariyle yepyeni bir dekorasyon çalışmasıyla Cafe & Patisserie olarak hizmetine devam etmektedir.',
    aboutText2: 'Ürünlerimizde bağımlılık yapan lezzeti veren en önemli özelliği kendi evlerimizde kullandığımız ürünleri, sizlere sunduğumuz çeşitlerin üretiminde kullanmamızdır, üründe Kalite, tüketicide Güven bizim ilkemiz bu doğrultudadır.',
    aboutText3: 'Siz müşterilerimizin memnuniyeti herşeyden önemlidir.',
    feature1Title: 'Kaliteli Malzeme',
    feature1Desc: 'Her ürünümüzde en kaliteli malzemeleri kullanıyoruz',
    feature2Title: 'Her Gün Taze',
    feature2Desc: 'Ürünlerimiz her gün taze olarak hazırlanır',
    feature3Title: 'Özenli Hazırlık',
    feature3Desc: 'Her ürün özenle ve sevgiyle hazırlanır',
    
    // Menu Section
    menuTitle: 'Menümüz',
    menuSubtitle: 'Geniş ürün yelpazemizi keşfedin',
    
    // Reviews Section
    reviewsTitle: 'Müşteri Yorumları',
    reviewsSubtitle: 'Müşterilerimiz ne diyor?',
    rating: 'Puan',
    basedOn: 'toplam',
    reviewsText: 'yoruma dayanıyor',
    
    // Gallery Section
    galleryTitle: 'Galeri',
    gallerySubtitle: 'Pastanemizden görüntüler',
    
    // Contact Section
    contactTitle: 'İletişim ve Konum',
    address: 'Adres',
    phone: 'Telefon',
    email: 'E-posta',
    hours: 'Çalışma Saatleri',
    services: 'Hizmetlerimiz',
    
    // Footer
    rights: 'Tüm hakları saklıdır.',
  },
  en: {
    // Navigation
    home: 'Home',
    about: 'About',
    menu: 'Menu',
    reviews: 'Reviews',
    gallery: 'Gallery',
    contact: 'Contact',
    
    // Hero Section
    heroTitle: 'Fresh Daily, Quality Always',
    heroSubtitle: 'Ankara\'s beloved pastry shop. Since 1971',
    viewMenu: 'View Menu',
    getDirections: 'Get Directions',
    callNow: 'Call Now',
    
    // About Section
    aboutTitle: 'About Us',
    aboutText1: 'Founded by Hüseyin Sünetci in 1971 on Başlayan Street in Ankara, Dere Pastanesi has expanded its range over time and continues to serve on Bülbülderesi Avenue, establishing itself among Ankara\'s first and most prominent pastry shops. Our patisserie continues to serve as a Cafe & Patisserie with a brand new decoration since 2007.',
    aboutText2: 'The most important feature that gives our products their addictive taste is that we use the same products in production that we use in our own homes. Quality in products and Trust in consumers is our principle in this direction.',
    aboutText3: 'The satisfaction of our customers is more important than anything else.',
    feature1Title: 'Quality Ingredients',
    feature1Desc: 'We use the highest quality ingredients in all our products',
    feature2Title: 'Fresh Daily',
    feature2Desc: 'Our products are prepared fresh daily',
    feature3Title: 'Careful Preparation',
    feature3Desc: 'Every product is prepared with care and love',
    
    // Menu Section
    menuTitle: 'Our Menu',
    menuSubtitle: 'Explore our wide range of products',
    
    // Reviews Section
    reviewsTitle: 'Customer Reviews',
    reviewsSubtitle: 'What our customers say',
    rating: 'Rating',
    basedOn: 'based on',
    reviewsText: 'reviews',
    
    // Gallery Section
    galleryTitle: 'Gallery',
    gallerySubtitle: 'Images from our pastry shop',
    
    // Contact Section
    contactTitle: 'Contact & Location',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    hours: 'Opening Hours',
    services: 'Our Services',
    
    // Footer
    rights: 'All rights reserved.',
  }
};

export const menuCategories = {
  tr: [
    {
      id: 1,
      name: 'Alman Pastası',
      description: '',
      items: []
    },
    {
      id: 2,
      name: 'Muzlu Rulo Pasta',
      description: '',
      items: []
    },
    {
      id: 3,
      name: 'Ankara Sarması',
      description: '',
      items: []
    },
    {
      id: 4,
      name: 'Ankara Sarma',
      description: '',
      items: []
    },
    {
      id: 5,
      name: 'Milfoy Pasta',
      description: '',
      items: []
    },
    {
      id: 6,
      name: 'Ispanaklı Börek Ve Çay',
      description: '',
      items: []
    },
    {
      id: 7,
      name: 'Çikolatalı Çilekli Yaş Pasta',
      description: '',
      items: []
    },
    {
      id: 8,
      name: 'Peynirli Pizza',
      description: '',
      items: []
    },
    {
      id: 9,
      name: 'Kütük Pasta',
      description: '',
      items: []
    },
    {
      id: 10,
      name: 'Frambuazlı Yaş Pasta',
      description: '',
      items: []
    },
    {
      id: 11,
      name: 'Profiterol',
      description: '',
      items: []
    }
  ],
  en: [
    {
      id: 1,
      name: 'German Cake',
      description: '',
      items: []
    },
    {
      id: 2,
      name: 'Banana Roll Cake',
      description: '',
      items: []
    },
    {
      id: 3,
      name: 'Ankara Sarması',
      description: '',
      items: []
    },
    {
      id: 4,
      name: 'Ankara Sarma',
      description: '',
      items: []
    },
    {
      id: 5,
      name: 'Mille-feuille Cake',
      description: '',
      items: []
    },
    {
      id: 6,
      name: 'Spinach Pastry With Tea',
      description: '',
      items: []
    },
    {
      id: 7,
      name: 'Chocolate Strawberry Fresh Cake',
      description: '',
      items: []
    },
    {
      id: 8,
      name: 'Cheese Pizza',
      description: '',
      items: []
    },
    {
      id: 9,
      name: 'Log Cake',
      description: '',
      items: []
    },
    {
      id: 10,
      name: 'Raspberry Fresh Cake',
      description: '',
      items: []
    },
    {
      id: 11,
      name: 'Profiterole',
      description: '',
      items: []
    }
  ]
};

export const customerReviews = {
  tr: [
    {
      id: 1,
      name: 'Berk B.',
      rating: 5,
      comment: 'Rulo pastayı çok beğendik.Şeker miktarından kremasının kıvamına,içindeki muzların tazeliğine kadar çok güzeldi.Sade,kaliteli ve lezzetli.😋',
      date: '2 hafta önce'
    },
    {
      id: 2,
      name: 'Zara G.',
      rating: 5,
      comment: 'Çok uygun fiyatlara çok çeşitli tatlılar ve fırın ürünleri vardı. Personel de çok nazik ve yardımseverdi. Ekler ve Milföy\'ü tercih ettik ve özellikle kremalı dolgusuna bayıldık.',
      date: '1 ay önce'
    },
    {
      id: 3,
      name: 'Zeynep G.',
      rating: 5,
      comment: 'Çatı pasta, milföy ve fırından yeni çıkmış poğaçalarını tattık. Hepsi birbirinden lezzetliydi. Milföy ince ve çıtır çıtırdı. Ürünler çok taze ama hızlı tükeniyor, erken gitmekte fayda var. ',
      date: '3 hafta önce'
    },
    {
      id: 4,
      name: 'Sinem M.',
      rating: 5,
      comment: 'Milfoy, muzlu rulo pasta ve profiterolunu denedik. Genel olarak lezzetliydi. Krema konusunda oldukca basarililar. Calisanlar cok ilgiliydi. Fiyatlar uygun.',
      date: '2 ay önce'
    }
  ],
  en: [
    {
      id: 1,
      name: 'Berk B.',
      rating: 5,
      comment: 'We really liked the roll cake. Everything was wonderful, from the amount of sugar to the consistency of the cream and the freshness of the bananas inside. Simple, high-quality, and delicious.',
      date: '2 weeks ago'
    },
    {
      id: 2,
      name: 'Zara G.',
      rating: 5,
      comment: 'They had a wide variety of desserts and baked goods at very reasonable prices. The staff were also very kind and helpful. We opted for the éclairs and mille-feuille and loved the creamy filling.',
      date: '1 month ago'
    },
    {
      id: 3,
      name: 'Zeynep G.',
      rating: 5,
      comment: 'We tried their rooftop cake, puff pastry, and freshly baked rolls. They were all delicious. The puff pastry was thin and crispy. The products are very fresh, but they sell out quickly, so it\'s best to go early.',
      date: '3 weeks ago'
    },
    {
      id: 4,
      name: 'Sinem H.',
      rating: 5,
      comment: 'We tried their mille-feuille, banana roll cake, and profiteroles. Overall, they were delicious. They are quite successful with their cream fillings. The staff were very attentive. The prices are reasonable.',
      date: '2 months ago'
    }
  ]
};

export const contactInfo = {
  businessName: 'Dere Pastanesi',
  phone: '(0312) 446 32 46',
  email: 'dere@dere.com.tr',
  address: {
    tr: 'Küçükesat, Bülbülderesi Cd. No:84, 06660 Çankaya / Ankara',
    en: 'Küçükesat, Bülbülderesi Cd. No:84, 06660 Çankaya / Ankara'
  },
  locationCode: 'WV68+2W Çankaya, Ankara',
  hours: {
    tr: 'Her gün açık • 21:20\'de kapanır',
    en: 'Open daily • Closes at 21:20'
  },
  services: {
    tr: ['Paket Servis', 'Ücretsiz Wi-Fi'],
    en: ['Delivery service', 'Free Wi-Fi']
  },
  rating: 4.7,
  totalReviews: 1225,
  mapUrl: 'https://www.google.com/maps/search/?api=1&query=K%C3%BC%C3%A7%C3%BCkesat%2C+B%C3%BClb%C3%BClderesi+Cd.+No%3A84%2C+06660+%C3%87ankaya+%2F+Ankara',
  coordinates: {
    lat: 39.8750,
    lng: 32.8167
  }
};

export const galleryImages = [
  {
    id: 1,
    url: 'https://customer-assets.emergentagent.com/job_9aeb426e-28fd-44eb-97f4-b51fb46abefb/artifacts/ul4gbmkw_WhatsApp%20Image%202025-12-30%20at%2012.56.50%20%283%29.jpeg',
    alt: 'Dere Pastanesi ürünleri'
  },
  {
    id: 2,
    url: 'https://customer-assets.emergentagent.com/job_9aeb426e-28fd-44eb-97f4-b51fb46abefb/artifacts/v8jbbnv6_WhatsApp%20Image%202025-12-30%20at%2012.56.50%20%282%29.jpeg',
    alt: 'Taze meyveli pastalar'
  },
  {
    id: 3,
    url: 'https://customer-assets.emergentagent.com/job_9aeb426e-28fd-44eb-97f4-b51fb46abefb/artifacts/vumy7fgu_WhatsApp%20Image%202025-12-30%20at%2012.56.50%20%281%29.jpeg',
    alt: 'Çikolatalı ekler'
  },
  {
    id: 4,
    url: 'https://customer-assets.emergentagent.com/job_9aeb426e-28fd-44eb-97f4-b51fb46abefb/artifacts/4o8429k0_WhatsApp%20Image%202025-12-30%20at%2012.56.49%20%281%29.jpeg',
    alt: 'Özel tatlılar'
  },
  {
    id: 5,
    url: 'https://customer-assets.emergentagent.com/job_9aeb426e-28fd-44eb-97f4-b51fb46abefb/artifacts/h8lfc2wt_WhatsApp%20Image%202025-12-30%20at%2012.56.50.jpeg',
    alt: 'Dere Pastanesi özel pasta'
  },
  {
    id: 6,
    url: 'https://customer-assets.emergentagent.com/job_9aeb426e-28fd-44eb-97f4-b51fb46abefb/artifacts/5x1rbg4y_WhatsApp%20Image%202025-12-30%20at%2012.56.49.jpeg',
    alt: 'Dere Pastanesi vitrin'
  }
];
